import ProductReviewItem from "./ProductReviewItem";
import {
  ReviewProduct,
  RatingSummary,
} from "@interfaces/dto/review.dto";
import { REVIEW_DEFAULT_PAGE } from "@const/products.const";
import ReviewStarProgress from "../../product-review/ReviewStarProgress";
import ReviewRate from "../../product-review/ReviewRate";
import ReviewFilter from "../../product-review/ReviewFilter";
import { ProductDetail } from "@interfaces/dto/product-detail.dto";

interface Props {
  dataReviewProduct: ReviewProduct[] | undefined;
  dataReviewSummary: RatingSummary[] | undefined;
  isLoadingReviewProducts: boolean;
  productDetail: ProductDetail;
  reviewCurrentPage: number;
  totalReviews: number;
  totalReviewsFilter: number;
  totalImageCount: number;
  setReviewCurrentPage: (page: number) => void;
  setFilteredReviewsRate: (rating: string) => void;
  setFilteredReviewsImg: (rating: string) => void;
}

const ProductCustomerReview = ({
  dataReviewProduct,
  dataReviewSummary,
  isLoadingReviewProducts,
  productDetail,
  reviewCurrentPage,
  totalReviews,
  totalReviewsFilter,
  totalImageCount,
  setReviewCurrentPage,
  setFilteredReviewsRate,
  setFilteredReviewsImg,
}: Props) => {

  const firstPage = () => {
    setReviewCurrentPage(REVIEW_DEFAULT_PAGE);
  };

  return (
    <>
      <div id="review-section" className="bg-white my-3 p-3 rounded-2">
        <div className="description">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="title my-auto">รีวิวสินค้า</h5>
          </div>
          <div className="comments">
            <div className="review p-auto">
              <div className="row d-flex justify-content-between">
                <ReviewRate
                  productDetail={productDetail}
                  totalReviews={totalReviews}
                  reviewSummary={dataReviewSummary!}
                />
                <ReviewStarProgress reviewSummary={dataReviewSummary!} />
                <ReviewFilter
                  setFilteredReviewsRate={setFilteredReviewsRate}
                  setFilteredReviewsImg={setFilteredReviewsImg}
                  goFirstPage={firstPage}
                  totalReviews={totalReviews}
                  reviewSummary={dataReviewSummary!}
                  totalImageCount={totalImageCount}
                />
              </div>
              <hr />
              <ul className="comment-list mt-4">
                <ProductReviewItem
                  dataReview={dataReviewProduct}
                  isLoadingReviewProducts={isLoadingReviewProducts}
                  reviewCurrentPage={reviewCurrentPage}
                  setReviewCurrentPage={setReviewCurrentPage}
                  totalReviewsFilter={totalReviewsFilter}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCustomerReview;
